/* Isolated carousel; no changes to cart, navigation or product forms. */
(() => {
  if (customElements.get('bif-campaign-controller')) return;
  class CampaignController extends HTMLElement {
    connectedCallback() {
      const root = this.closest('[data-bf-campaign]');
      const slides = [...root.querySelectorAll('[data-campaign-slide]')];
      if (slides.length < 2) return;
      const tabs = [...root.querySelectorAll('[data-campaign-tab]')];
      const pause = root.querySelector('[data-campaign-pause]');
      const reduced = matchMedia('(prefers-reduced-motion: reduce)');
      const events = new AbortController();
      const on = (el, name, fn, options = {}) => el?.addEventListener(name, fn, {...options, signal:events.signal});
      let current = 0, timer, paused = reduced.matches, hovering = false, focused = false, dragging = false, start = null, suppressClick = false;
      const delay = Number(root.dataset.delay) || 7000;
      const autoplay = root.dataset.autoplay === 'true';
      const pauseState = () => {
        pause?.setAttribute('aria-label', paused ? 'Play slideshow' : 'Pause slideshow');
        pause?.setAttribute('aria-pressed', String(paused));
        pause?.querySelector('path').setAttribute('d', paused ? 'm8 5 10 7-10 7V5Z' : 'M9 5v14M15 5v14');
      };
      const schedule = () => {
        clearTimeout(timer);
        if (autoplay && !paused && !hovering && !focused && !dragging && !document.hidden && !window.Shopify?.designMode) timer = setTimeout(() => show(current + 1), delay);
      };
      const show = (index, manual = false) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide,i) => { slide.hidden = i !== current; });
        tabs.forEach((tab,i) => tab.setAttribute('aria-pressed',String(i === current)));
        if (manual) {
          paused = true;
          pauseState();
          root.querySelector('[data-campaign-status]').textContent = `${current+1} of ${slides.length}: ${tabs[current].innerText.replace(/^0\d\s*/, '').replace('↗','')}`;
        }
        schedule();
      };
      tabs.forEach((tab,i) => on(tab,'click',()=>show(i,true)));
      on(root.querySelector('[data-campaign-prev]'),'click',()=>show(current-1,true));
      on(root.querySelector('[data-campaign-next]'),'click',()=>show(current+1,true));
      on(pause,'click',()=>{paused=!paused;pauseState();schedule()});
      on(root,'pointerenter',e=>{if(e.pointerType==='mouse'){hovering=true;schedule()}});
      on(root,'pointerleave',e=>{if(e.pointerType==='mouse'){hovering=false;schedule()}});
      on(root,'focusin',()=>{focused=true;schedule()});
      on(root,'focusout',()=>queueMicrotask(()=>{focused=root.contains(document.activeElement);schedule()}));
      on(document,'visibilitychange',schedule);
      on(reduced,'change',()=>{paused=reduced.matches;pauseState();schedule()});
      on(root,'keydown',e=>{
        if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
        const wasLink = e.target.closest('.bf-campaign__link');
        e.preventDefault();show(current+(e.key==='ArrowRight'?1:-1),true);
        if (wasLink) slides[current].querySelector('a').focus({preventScroll:true});
        else if (e.target.matches('[data-campaign-tab]')) tabs[current].focus({preventScroll:true});
      });
      const viewport = root.querySelector('.bf-campaign__viewport');
      on(viewport,'touchstart',e=>{start=e.touches.length===1?{x:e.touches[0].clientX,y:e.touches[0].clientY}:null;dragging=true;schedule()},{passive:true});
      on(viewport,'touchmove',e=>{if(e.touches.length!==1)start=null},{passive:true});
      on(viewport,'touchcancel',()=>{start=null;dragging=false;schedule()},{passive:true});
      on(viewport,'touchend',e=>{
        dragging=false;
        if (start && e.changedTouches.length) {
          const dx=e.changedTouches[0].clientX-start.x,dy=e.changedTouches[0].clientY-start.y;
          if (Math.abs(dx)>50 && Math.abs(dx)>Math.abs(dy)*1.4) {
            suppressClick=true;show(current+(dx<0?1:-1),true);
            setTimeout(()=>{suppressClick=false},400);
          }
        }
        start=null;schedule();
      },{passive:true});
      on(viewport,'click',e=>{if(suppressClick){e.preventDefault();e.stopPropagation()}},{capture:true});
      on(document,'shopify:block:select',e=>{const i=slides.findIndex(s=>s.contains(e.target)||s===e.target);if(i>=0)show(i,true)});
      pauseState();schedule();
      this.cleanup = () => {clearTimeout(timer);events.abort()};
    }
    disconnectedCallback() {this.cleanup?.()}
  }
  customElements.define('bif-campaign-controller',CampaignController);
  const init = (scope=document) => scope.querySelectorAll('[data-bf-campaign]').forEach(root=>{
    if (!root.querySelector('bif-campaign-controller')) root.append(document.createElement('bif-campaign-controller'));
  });
  init();document.addEventListener('shopify:section:load',e=>init(e.target));
})();
